import { all } from "redux-saga/effects"
import LoginSaga from './LoginSaga'
import LoginForgetPassSaga from './LoginForgetPassSaga'
import LoginResetPassSaga from "./LoginResetPassSaga"
import StoreListSaga from "./StoreListSaga"
import CustomerListSaga from "./CustomerListSaga"
import VendorProfileSaga from "./VendorProfileSaga"
import VendorAddressSaga from "./VendorAddressSaga"
import ProductListSaga from "./ProductListSaga"
import CategoryListSaga from "./CategorySaga"
import FlagshipListSaga from "./FlagshipListSaga"
import TopSellingProductSaga from "./TopSellingProductSaga"
import RequestCategoriesSaga from "./RequestCategoriesSaga"
import VouchersListSaga from "./ActiveVouchersListSaga"
import InActiveVouchersListSaga from "./InActiveVouchersListSaga"
import BrandSaga from "./BrandSaga"
import RequestBrandSaga from "./RequestBrandSaga"
import AttributesSaga from "./AttributesSaga"
import RequestAttributesSaga from "./RequestAttributesSaga"
import ActiveAdsSaga from "./ActiveAdsSaga"
import InactiveAdsSaga from "./InactiveAdsSaga"
import MostSpentCustomersSaga  from './MostSpentCustomersSaga'
import TopCustomersSaga from './TopCustomersSaga'
import OrdersListSaga from "./OrdersListSaga"
import VendorAnalyticsSaga  from "./VendorAnalyticsSaga"
import UsersAnalyticsSaga from './UsersAnalyticsSaga'
import OrdersAnalyticsSaga from './OrdersAnalyticsSaga'
import PickupAnalyticsSaga from'./PickupAnalyticsSaga'

export default function* rootSaga() {
    yield all([
        LoginSaga(),
        LoginForgetPassSaga(),
        LoginResetPassSaga(),
        StoreListSaga(),
        VendorProfileSaga(),
        VendorAddressSaga(),
        CustomerListSaga(),
        ProductListSaga(),
        CategoryListSaga(),
        FlagshipListSaga(),
        TopSellingProductSaga(),
        RequestCategoriesSaga(),
        VouchersListSaga(),
        InActiveVouchersListSaga(),
        BrandSaga(),
        RequestBrandSaga(),
        AttributesSaga(),
        RequestAttributesSaga(),
        ActiveAdsSaga(),
        InactiveAdsSaga(),
        MostSpentCustomersSaga(),
        TopCustomersSaga(),
        OrdersListSaga(),
        VendorAnalyticsSaga(),
        UsersAnalyticsSaga(),
        OrdersAnalyticsSaga(),
        PickupAnalyticsSaga(),


    ])
}
